import { testimonialConstants } from "./constants/testimonialConstant";

const testimonialGetByFilter = (data:any) => {
	return {
		type: testimonialConstants.Testimonial_GetByFilter_Request,
		input: data,
	};
};

const testimonialGetDetail = (id: any) => {
	return {
		type: testimonialConstants.TestimonialDetailRequest,
		input: id,
	};
};

const updateTestimonialStatus = (data: any) => {
	return {
		type: testimonialConstants.TestimonialStatusUpdateRequest,
		input: data,
	};
};

const updateTestimonialVideoStatus = (data: any) => {
	return {
		type: testimonialConstants.TestimonialVideoStatusUpdateRequest,
		input: data,
	};
};

export const testimonialAction = {
	testimonialGetByFilter,
	testimonialGetDetail,
	updateTestimonialStatus,
	updateTestimonialVideoStatus,
};
